export const timetable = {
    myTimetable: "내 시간표",
    examTimetable: "시험시간표",
    addLectureConflict: "시간표가 겹치는 강의를 추가할 수 없습니다.",
    pasteLectureConflict:
        "시간이 겹치는 과목이 있습니다. 겹치는 기존 과목을 지우고 붙여넣으시겠습니까?",
    myTimeTableLectureAddWarning: "내 시간표에는 강의를 추가할 수 없습니다.",
    timetableKeyboardDeleteConfirm: "현재 시간표를 삭제하시겠습니까?",
    copyImage: "이미지로 복사하기",
    exportImage: "이미지로 내보내기",
    exportICal: "캘린더로 내보내기",
    addToWishlist: "찜목록에 추가",
    addToTimetable: "시간표에 추가",
    removeFromWishlist: "찜목록에서 제거",
    removeFromTimetable: "시간표에서 제거",
    competitionRate: "경쟁률",
    noTimeInfo: "시간 정보 없음",
    numSelected: "개 과목 선택됨",
    shortcuts: {
        modalTitle: "단축키 안내",
        lectureSection: "과목 편집",
        timetableSection: "시간표 조작",
        etcSection: "기타 네비게이션",
        lectureMultiple: "과목 다중 선택 / 선택 해제",
        lectureCopy: "선택된 과목 복사",
        lectureCut: "선택된 과목 잘라내기",
        lecturePaste: "복사 / 잘라낸 과목 붙여넣기",
        lectureAll: "시간표의 과목 전체 선택",
        lectureDelete: "선택된 과목 삭제",
        timetableUndo: "실행 취소 (시간표 별로 관리됨)",
        timetableRedo: "다시 실행 (시간표 별로 관리됨)",
        timetableAdd: "빈 시간표 추가",
        timetableDuplicate: "현재 시간표 복제",
        timetableDelete: "현재 시간표 삭제 (선택된 과목이 없을 시)",
        timetableSelect: "시간표 탭 이동",
        etcSemester: "학기 이동",
        etcLectureSearchMove: "검색 결과 내 탐색",
        etcLectureAddDelete: "탐색중인 과목 추가 / 제거",
        etcSelectCancel: "선택 취소",
        etcShortcutInfo: "단축키 안내 보기",
    },
    addCustomBlock: "커스텀 블록 추가",
    customBlock: {
        name: "일정 이름",
        place: "장소",
        timetable: "시간표",
        time: "시간",
        add: "시간표에 추가하기",
        save: "저장하기",
        overlap: "해당 시간과 겹치는 커스텀 블록이 있습니다.",
        errorNameRequired: "일정 이름을 입력해주세요.",
        errorTimeInvalid: "종료 시간은 시작 시간보다 늦어야 합니다.",
    },
}
